module.exports = global["$"] = require("-!/var/www/repos/luckyyou/miele/wp-content/themes/miele/node_modules/babel-loader/lib/index.js!./jquery.js");